import { mixed, number, object } from "yup";
import { FeatureId } from "./ClinicFeatureResource";

export interface PlanFeatureResource {
  id: number;
  feature: {
    id: FeatureId;
  };
  value: number;
}

export const planFeatureResourceSchema = object({
  id: number().required(),
  feature: object({
    id: mixed<FeatureId>()
      .oneOf(Object.values(FeatureId) as FeatureId[])
      .required(),
  }).required(),
  value: number().required(),
});
